/** Agrupa cantidades de la propuesta por material y depósito para su visualización. */
export const consolidatedMaterialTotals = (rows) => {
  const grouped = new Map();
  rows.forEach((row) => {
    const key = `${row.uuid_inventory_article}:${row.uuid_destination_warehouse}`;
    const current = grouped.get(key) || {
      ...row, uuid_external_order_item: key, quantity: 0, available_quantity: 0,
    };
    current.quantity += Number(row.quantity || 0);
    current.available_quantity += Number(row.available_quantity);
    grouped.set(key, current);
  });
  return [...grouped.values()].map((row) => ({
    ...row,
    quantity: Math.round(row.quantity * 1000) / 1000,
    available_quantity: Math.round(row.available_quantity * 1000) / 1000,
  }));
};
